require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/$.wks')('iterator');


//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/core-js/library/fn/symbol/iterator.js
// module id = 226
// module chunks = 0